import { Fetcher } from '@this/src/util';

export type UserChatRule = {
  calendarRuleText: string;
};

type RawUserChatRule = {
  calendar_rule_text: string | null;
};

type UserChatRuleResponse = {
  trip_ai_user_chat_rule: RawUserChatRule;
};

const normalizeUserChatRule = (rule: RawUserChatRule): UserChatRule => ({
  calendarRuleText: rule.calendar_rule_text || ''
});

export const fetchUserChatRule = async (): Promise<UserChatRule> => {
  const response = await Fetcher.get<UserChatRuleResponse>('/trips/ai_messages/user_chat_rule');
  return normalizeUserChatRule(response.trip_ai_user_chat_rule);
};

export const updateUserChatRule = async (params: UserChatRule): Promise<UserChatRule> => {
  const response = await Fetcher.patch<UserChatRuleResponse>('/trips/ai_messages/user_chat_rule', {
    trip_ai_user_chat_rule: {
      calendar_rule_text: params.calendarRuleText
    }
  });
  return normalizeUserChatRule(response.trip_ai_user_chat_rule);
};
